// extracted by mini-css-extract-plugin
export var divider = "_s5-0";
export var systemMessage = "_s5-1";
export var systemMessageWrapper = "_s5-2";